import { render, staticRenderFns } from "./AtomCreator.vue?vue&type=template&id=cfd5edca&scoped=true&"
import script from "./AtomCreator.vue?vue&type=script&lang=js&"
export * from "./AtomCreator.vue?vue&type=script&lang=js&"
import style0 from "./AtomCreator.vue?vue&type=style&index=0&id=cfd5edca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd5edca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
